import React, { useEffect, useState } from "react";
import { API } from "../../../App";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Link,
  IconButton,
  Collapse,
  Box,
} from "@mui/material";

import Paper from "@mui/material/Paper";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

function ListProcedures() {
  // Table style
  const mainTableHeaderStyle = { color: "white", fontSize: "2rem" };
  const mainTableRowStyle = { color: "white", fontSize: "1.7rem" };

  const subTableHeaderStyle = { color: "white", fontSize: "1.9rem" };
  const subTableRowStyle = { color: "white", fontSize: "1.7rem" };
  const tableActionsStyle = {
    color: "white",
    fontSize: "1.9rem",
    align: "right",
  };

  const [procedures, setProcedures] = useState([]);

  /**
   *
   */
  const getProcedures = async () => {
    const proceduresResponse = await fetch(`${API}/api/admin/procedures`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage["tk"]}`,
      },
    })
      .then((res) => {
        if (res.status === 401) {
          localStorage.removeItem("tk");
          window.location.href = "/admin";
        } else {
        }
        return res.json();
      })
      .catch((err) => {
        console.log("error: ", err);
      });
    setProcedures(proceduresResponse);
  };

  /**
   *
   */
  useEffect(() => {
    getProcedures();
  }, []);

  function Row(props) {
    const { post: procedure } = props;
    const [open, setOpen] = React.useState(false);

    return (
      <React.Fragment>
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell style={mainTableRowStyle}>{procedure.name}</TableCell>
          <TableCell
            style={mainTableRowStyle}
            dangerouslySetInnerHTML={{ __html: procedure.description }}
          ></TableCell>
          <TableCell style={mainTableRowStyle}>
            {procedure.createdAt?.substring(0, 10)}
          </TableCell>
          <TableCell style={mainTableRowStyle}>
            {" "}
            {procedure.active ? "Activo" : "Inactivo"}
          </TableCell>
          <TableCell style={tableActionsStyle}>
            <Link href={`/admin/panel/procedures/${procedure.id}/edit`}>
              <EditIcon color="primary" />{" "}
            </Link>
            <IconButton
              style={mainTableHeaderStyle}
              aria-label="expand row"
              size="medium"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
        </TableRow>

        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell style={subTableHeaderStyle}></TableCell>
                      <TableCell style={subTableHeaderStyle}>Fecha</TableCell>
                      <TableCell style={subTableHeaderStyle}>Archivo</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {procedure.contents.map((content) => (
                      <TableRow key={content.id}>
                        <TableCell style={subTableRowStyle}>
                          <img
                            width="40px"
                            height="40px"
                            src={`/${content.extension}.png`}
                            srcSet={`/${content.extension}.png`}
                            alt={`/${content.extension}.png`}
                            loading="lazy"
                          />
                        </TableCell>
                        <TableCell style={subTableRowStyle}>
                          {content.createdAt?.substring(0, 10)}
                        </TableCell>
                        <TableCell style={subTableRowStyle}>
                          <Link
                            href={`/content/${content.path}`}
                            target="_blank"
                          >
                            {" "}
                            {content.name}{" "}
                          </Link>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  return (
    <TableContainer style={{ backgroundColor: "#010b2a" }} component={Paper}>
      <Table sx={{ minWidth: 850 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell style={mainTableHeaderStyle}>Título</TableCell>
            <TableCell style={mainTableHeaderStyle}>Descripcion</TableCell>
            <TableCell style={mainTableHeaderStyle}>
              Fecha Publicación
            </TableCell>
            <TableCell style={mainTableHeaderStyle}>Estado</TableCell>
            <TableCell style={mainTableHeaderStyle}>
              <Link href="/admin/panel/procedures/new">
                <AddIcon color="primary" />
              </Link>
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {procedures.map((post) => (
            <Row key={post.id} post={post} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
export default ListProcedures;
